import React, { useState, useMemo, useEffect, useRef} from 'react';
import { Placeholder, RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import StickyTopWrapper from './components/@shared/StickyTopWrapper';
import Helmet from 'react-helmet';


const Layout = ({ route, sitecoreContext }) => {

  const matomoId = route?.fields['MatomoId']?.value
  const matomoTagManagerContainer =
    route?.fields['MatomoTagManagerContainer']?.value

  const scriptURL = `https://cdn.cookielaw.org/consent/${sitecoreContext?.ContextExtensions?.onetrustcookie?.value}/OtAutoBlock.js`
  const mounted = useRef(true)
  const [forceRender, setForceRender] = useState(false)

  useEffect(() => {
    var d = document,
      g = d.createElement('link'),
      s = d.getElementsByTagName('head')[0]
    g.rel = 'icon'
    g.type = 'image/JPG'
    g.href =
      window.location?.protocol +
      `//` +
      window.location?.host +
      '/' +
      sitecoreContext?.ContextExtensions?.favicon?.value
    s.appendChild(g)
  }, [])

  useEffect(() => {
    if (!matomoId || !matomoTagManagerContainer) {
      return
    }

    var _mtm = (window._mtm = window._mtm || [])
    _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' })
    var d = document,
      g = d.createElement('script'),
      s = d.getElementsByTagName('script')[0]
    g.type = 'text/javascript'
    g.async = true
    g.src =
      'https://matomo.cnhind.com/agce/js/container_' +
      matomoTagManagerContainer +
      '.js'
    s.parentNode.insertBefore(g, s)

    var _paq = (window._paq = window._paq || [])
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView'])
    _paq.push(['enableLinkTracking'])
    ;(function () {
      var u = 'https://matomo.cnhind.com/agce/'
      _paq.push(['setTrackerUrl', u + 'matomo.php'])
      _paq.push(['setSiteId', matomoId])
      var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0]
      g.type = 'text/javascript'
      g.async = true
      g.src = u + 'matomo.js'
      s.parentNode.insertBefore(g, s)
    })()
  }, [])

  useEffect(() => {
    //let customElements = window.customElements;
    customElements.whenDefined('pfe-icon').then(function () {
      const PfeIcon = customElements.get('pfe-icon')
      const setName = 'cnh'
      //const newSetPath = "https://eucomcrg04-123710-cd.azurewebsites.net/corporate/sitecore/media library/Onhighwayicons/cnh-icons";

      // let newSetPath = //localhost abilitare per vedere le icone / non committare
      //   'http://cnhi001.westeurope.cloudapp.azure.com/cnhicorporate/-/media/cnh-icons' //localhost abilitare per vedere le icone / non committare
      let newSetPath = '/-/media/cnh-icons' //production

      // let newSetPath = "/-/media/Onhighwayicons/cnh-icons"

      // function to return the complete path of the icon
      function newResolveNameFn(iconName, setName, path) {
        return `${path}/${iconName}.svg`
      }
      PfeIcon.addIconSet(setName, newSetPath, newResolveNameFn)

      PfeIcon.defaultThemeSetInfo = {
        path: newSetPath,
        resolveIconName: newResolveNameFn,
      }

      // do what you need with the class here
    })
  }, [])

  const [loading, setLoading] = useState(false)

  if (typeof window !== 'undefined') {
    const element = document.querySelector('.spinner-page')
    useEffect(() => {
      setLoading(true)
      setTimeout(() => {
        mounted.current = true
        setForceRender(!forceRender)
        {
          element ? element.remove() : ''
        }
        setLoading(false)
      }, 1)

      return () => {
        mounted.current = false
      }
    }, [route])
  }

  const LoadingOverlay = useMemo(() => {
    return () => (
      <div className="spinner-page">
        <svg version="1.0" width="64px" height="64px" viewBox="0 0 128 128">
          <g>
            <circle cx="16" cy="64" r="16" fill="#B4282E" />
            <circle
              cx="16"
              cy="64"
              r="14.344"
              fill="#B4282E"
              transform="rotate(45 64 64)"
            />
            <circle
              cx="16"
              cy="64"
              r="12.531"
              fill="#B4282E"
              transform="rotate(90 64 64)"
            />
            <circle
              cx="16"
              cy="64"
              r="10.75"
              fill="#B4282E"
              transform="rotate(135 64 64)"
            />
            <circle
              cx="16"
              cy="64"
              r="10.063"
              fill="#B4282E"
              transform="rotate(180 64 64)"
            />
            <circle
              cx="16"
              cy="64"
              r="8.063"
              fill="#B4282E"
              transform="rotate(225 64 64)"
            />
            <circle
              cx="16"
              cy="64"
              r="6.438"
              fill="#B4282E"
              transform="rotate(270 64 64)"
            />
            <circle
              cx="16"
              cy="64"
              r="5.375"
              fill="#B4282E"
              transform="rotate(315 64 64)"
            />
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64"
              calcMode="discrete"
              dur="720ms"
              repeatCount="indefinite"
            />
          </g>
        </svg>
      </div>
    )
  }, [])

  useEffect(() => {
    document.documentElement.setAttribute(
      'lang',
      sitecoreContext?.language?.split('-')?.[0]
    )
  }, [])

  return (
    <React.Fragment>
      {loading ? (
        <LoadingOverlay />
      ) : (
        sitecoreContext?.ContextExtensions?.bodyscript && (
          <RichText
            field={sitecoreContext.ContextExtensions.bodyscript}
            style={{ display: 'none' }}
          />
        )
      )}
      <Helmet>
        <title>
          {`${route?.fields?.MetaTitle?.value} | ${route?.fields?.ExtendedMetaData?.fields?.BrandName?.value}`}
        </title>
        <meta name="keywords" content={route?.fields['MetaKeywords']?.value} />
        <meta
          name="description"
          content={route?.fields['MetaBrandDescription']?.value}
        />

        <meta
          property="og:title"
          content={`${route?.fields?.MetaTitle?.value} | ${route?.fields?.ExtendedMetaData?.fields?.BrandName?.value}`}
        />
        <meta property="og:url" content={route?.fields['MetaUrl']?.value} />
        <meta
          property="og:image"
          content={route?.fields['MetaImage']?.value?.src}
        />
        <meta property="og:type" content={route?.fields['MetaType']?.value} />
        <meta
          property="og:description"
          content={route?.fields['MetaBrandDescription']?.value}
        />
        <meta property="og:locale" content={sitecoreContext?.language} />

        <meta name="twitter:card" content={'summary'} />
        <meta name="twitter:site" content={route?.fields['MetaSite']?.value} />
        <meta
          name="twitter:title"
          content={`${route?.fields?.MetaTitle?.value} | ${route?.fields?.ExtendedMetaData?.fields?.BrandName?.value}`}
        />
        <meta
          name="twitter:description"
          content={route?.fields['MetaBrandDescription']?.value}
        />
        <meta
          name="twitter:image"
          content={route?.fields['MetaImage']?.value?.src}
        />
        {/* <link
          rel='icon'
          type='image/JPG'
          href={sitecoreContext?.ContextExtensions?.favicon?.value}
        /> */}

        <script type="application/ld+json">
          {JSON.stringify({
            '@sitecoreContext': 'https://schema.org',
            '@type': 'Corporation',
            name: route?.fields?.ExtendedMetaData?.fields?.BrandName?.value,
            description: route?.fields['MetaBrandDescription']?.value,
            url: route?.fields['MetaUrl']?.value,
            logo: route?.fields['ExtendedMetaData']?.fields?.OfficialLogo?.value
              ?.src,
            sameAs: route?.fields[
              'ExtendedMetaData'
            ]?.fields?.SocialMediaLinks?.map(
              (link) => link?.fields?.URL?.value?.url
            ),
          })}
        </script>

        {sitecoreContext?.ContextExtensions?.onetrustcookie?.value &&
          sitecoreContext?.ContextExtensions?.onetrustcookie?.value.trim() != '' && (
            <script type="text/javascript" src={scriptURL}></script>
          )}

        {sitecoreContext?.ContextExtensions?.onetrustcookie?.value &&
          sitecoreContext?.ContextExtensions?.onetrustcookie?.value.trim() != '' && (
            <script
              src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
              type="text/javascript"
              charset="UTF-8"
              data-document-language="true"
              data-domain-script={
                sitecoreContext.ContextExtensions.onetrustcookie.value
              }
            />
          )}

        <link
          rel="canonical"
          href={
            route?.fields?.CanonicalLink?.value?.href ||
            route?.fields['MetaUrl']?.value
          }
        ></link>
        {(Array.isArray(route?.fields?.AlternateLinks)
          ? route?.fields?.AlternateLinks?.value
          : []
        ).map((item, index) => (
          <link
            key={index}
            rel="alternate"
            hreflang={item.Name}
            href={item.Value}
          ></link>
        ))}
      </Helmet>
      {/*
      VisitorIdentification is necessary for Sitecore Analytics to determine if the visitor is a robot.
      If Sitecore XP (with xConnect/xDB) is used, this is required or else analytics will not be collected for the JSS app.
      For XM (CMS-only) apps, this should be removed.

      VI detection only runs once for a given analytics ID, so this is not a recurring operation once cookies are established.
    */}
      {/* <VisitorIdentification /> */}
      
      <header>
        <Placeholder name="jss-header" rendering={route} />
        <StickyTopWrapper />
      </header>
      <main>
        <Placeholder
          name="jss-main"
          rendering={route}
          render={(items) => {
            if (items[0]) {
              const firstItem = items[0];
              items[0] = React.cloneElement(firstItem, { isFirst: true });
            }

            items.forEach((item, index) => {
              if (
                item?.props?.rendering?.componentName === 'VerticalNavBar'
              ) {
                const vbar = items[index]
                items[index] = React.cloneElement(vbar, { data: route })
              }
            });
            return items;
          }}
        />
      </main>
      <footer id="root-footer">
        <Placeholder name="jss-footer" rendering={route} />
        <Placeholder name="jss-cookie-policy-banner" rendering={route} />
      </footer>
    </React.Fragment>
  );
};

export default withSitecoreContext()(Layout);
